import {
	type EventParams,
	EventStore,
	isGoogleAnalyticsEventName,
	Logger,
	pubSubService,
	Service,
	type SessionData,
	type TrackingEventType,
	TrackingService
} from '@capsicum/common';
import { type Analytics, logEvent, setUserId } from 'firebase/analytics';

import { initializeFirebaseAnalytics } from '../../util/firebase/initializeFirebaseAnalytics';

export class GoogleAnalyticsTracking extends TrackingService<EventParams> {
	protected override userId: string;

	private _analytics: Analytics;
	private _unsubscribe: ReturnType<typeof pubSubService.subscribe>;

	constructor() {
		super();
		this.userId = '';
		this._analytics = initializeFirebaseAnalytics();

		this._unsubscribe = pubSubService.subscribe<null | SessionData>([EventStore.SESSION_UPDATED], session => {
			this.setUserId(session?.userId ?? '');
		});
	}

	get analytics() {
		return this._analytics;
	}

	get serviceId(): Service {
		return Service.GOOGLE_ANALYTICS;
	}

	public destroy() {
		this._unsubscribe();
	}

	public getParams(params: EventParams) {
		return params;
	}

	public setThirdPartySharing() {
		// DO NOTHING
	}

	public async setUserId(userId: string) {
		this.userId = userId;
		setUserId(this._analytics, userId === '' ? null : userId);
	}

	public sendEvent(_: TrackingEventType.track, eventName: string, params?: EventParams) {
		if (!isGoogleAnalyticsEventName(eventName)) return;

		try {
			logEvent(this._analytics, eventName.replace(/^GA::/, ''), params);
		} catch (e) {
			Logger.error('Error google analytics event', e as Error);
		}
	}
}
